var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",class:[{ _warning: _vm.warning }, _vm.modify]},[_c('icon',{staticClass:"notification__main-icon",attrs:{"name":_vm.icon}}),_c('span',{staticClass:"notification__text"},[_vm._t("default")],2),(_vm.warning && !_vm.clickable)?_c('icon',{attrs:{"name":"warning"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }